import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgBank = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m3.407 8.409 8.198-5.293a.73.73 0 0 1 .79 0l8.2 5.293a.73.73 0 0 1 .333.613v.575a.73.73 0 0 1-.73.73H3.802a.73.73 0 0 1-.73-.73v-.575a.73.73 0 0 1 .335-.613M12 7.264v.01"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m20.955 20.38-.387-1.755a.51.51 0 0 0-.498-.4H3.93a.51.51 0 0 0-.499.4l-.387 1.755a.51.51 0 0 0 .499.62h16.915a.51.51 0 0 0 .497-.62"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M14.257 10.326v7.9m4.514-7.9v7.9m-13.544-7.9v7.9m4.514-7.9v7.9"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgBank);
export default ForwardRef;
